package com.nonopn.skydome.common.app.navigation

import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.account.AccountScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.title_account
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteAccount : RouteParameterTo

object RouterAccount : RouterNoParameters<RouteAccount>(RouteAccount::class) {
    override fun routeFrom(parameters: RouteAccount) = "/account"

    @Composable
    override fun Show(parameters: RouteAccount) {
        RouteAccountImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteAccount,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(launchSingleTop = true)
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteAccount

    override fun isMatching(route: String) = route == "/account"

    override fun navigateFrom(path: String) = RouteAccount
}

class RouteAccountImpl : Route<RouteAccount>(
    route = "/account",
    params = RouteAccount,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            appModel.setAppBarState(
                AppBarState.Localized(
                    title = Res.string.title_account,
                    listOf(
                        MenuItem.MenuItemSimple(
                            imageVector = Icons.Rounded.Logout,
                            onClick = { appModel.logout() }
                        )
                    )
                )
            )
        }

        val state by appModel.states.collectAsState()

        if (null == state.apiProvider?.apiNormal) return

        AccountScreen()
    }
}
